/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ISignInItem,
    ISignInLoading,
    ISignInLocalAccount,
    ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/sign-in';
import SignInLink from './components/sign-in-link';
import { ISignInResources } from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/sign-in.props.autogenerated';

interface IExtendedSignInViewProps extends ISignInViewProps {
    resources: ISignInResources;
    app: { [x: string]: any };
    context: { [x: string]: any };
}

const LocalAccount: React.FC<ISignInLocalAccount> = ({ localAccount, items, forgetPassword, disclaimer, error, signInButton }) => {
    return (
        <Node {...localAccount}>
            {items &&
                items.map((item: ISignInItem) => {
                    return (
                        <Node key={item.key} {...item.wrapper}>
                            {item.label}
                            {item.error}
                            {item.input}
                        </Node>
                    );
                })}
            {forgetPassword}
            {disclaimer}
            {error}
            {signInButton}
        </Node>
    );
};

const SignInLoading: React.FC<ISignInLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<IExtendedSignInViewProps> = props => {
    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        signUpSectionHeading,
        signUpDescription,
        resources,
        app,
        context
    } = props;

    const pathToSignIn =
        context?.request?.requestUrl?.split(context?.request?.sitePath)[0] + app.routes?.businessPartnerSelection?.destinationUrl;

    return (
        <Module {...signIn}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount)}
                </Node>
                <Node {...signUpSection}>
                    {signUpSectionHeading}
                    {signUpDescription}
                    <SignInLink
                        id='nosCreateAccount'
                        // attention here! businessPartnerSelection refers to become a business partner!
                        href={pathToSignIn}
                        // hardcoded module className
                        className={`ms-button__primary-dark msc-btn`}
                        ariaLabel={resources.signUpButtonAriaLabel}
                        text={resources.signUpButtonText}
                    />
                </Node>
            </Node>
        </Module>
    );
};

export default SignInView;
